// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  IAddFlatTourBookingRequest,
  TAddFlatTourBookingModel,
  IMappers,
  TAddFlatTourBookingResponse,
  IAddFlatTourBookingResponse,
  IAddFlatTourBookingResponseError,
} from './types';

export const defaultConfig: TAddFlatTourBookingModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'POST',
  microserviceName: 'newbuilding-flat-tour-booking',
  pathApi: '/v1/add-flat-tour-booking',
  requestType: 'json',
} as TAddFlatTourBookingModel;

export function createAddFlatTourBookingModel(parameters: IAddFlatTourBookingRequest): TAddFlatTourBookingModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IAddFlatTourBookingOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IAddFlatTourBookingRequest;
}

export async function fetchAddFlatTourBooking<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IAddFlatTourBookingOptions<TResponse200, TResponse400>): Promise<
  TAddFlatTourBookingResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(createAddFlatTourBookingModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IAddFlatTourBookingResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as IAddFlatTourBookingResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TAddFlatTourBookingResponse;
}
